import {Component, EventEmitter, Input, NgZone, OnInit, Output, ViewChild} from '@angular/core';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import {Travel} from '../../models/travel';
import {Vehicle} from '../../models/vehicle';
import {TravelsHandlerService} from '../../api-handlers/travels-handler.service';

@Component({
  selector: 'app-admin-change-travels',
  templateUrl: './admin-change-travels.component.html',
  styleUrls: ['./admin-change-travels.component.css']
})
export class AdminChangeTravelsComponent implements OnInit {

  modalRef: BsModalRef;
  travel_to_update: any;

  @Output() travelsModified = new EventEmitter<Vehicle>();
  @ViewChild('template', { static: false }) template;

  travel_status: string;
  travel_status_description: string;

  input_disabled_mapping = {
    trv_start_kilometers: true,
    trv_end_kilometers: true,
    trv_ended_at: true,
    trv_fuel_level: true
  };

  button_disabled_status_mapping = {
    btn_chiudi: true,
    btn_riapri: true,
    btn_modKM: true,
    btn_modifica: true
  };

  buttonUpdateDisabled = true;

  btnClicked: string;

  constructor(
    private modalService: BsModalService,
    private travelsHandlerService: TravelsHandlerService,
    private ngZone: NgZone
  ) { }

  ngOnInit() {
  }

  showDialog(travel: any) {
    this.travel_to_update = travel;
    this.travel_status = this.travelsHandlerService.getTravelStatus(travel);
    this.travel_status_description = this.travelsHandlerService.getTravelStatusDescription(this.travel_status);
    this.buttonDisabler();
    this.input_disabled_mapping.trv_start_kilometers = true;
    this.input_disabled_mapping.trv_end_kilometers = true;
    this.input_disabled_mapping.trv_ended_at = true;
    this.input_disabled_mapping.trv_fuel_level = true;
    this.modalRef = this.modalService.show(this.template, {class: 'modal-dialog-centered', ignoreBackdropClick :true});
  }


  updateTravel(){
    //chiama servizio be
    this.travelsHandlerService.adminUpdateTravel(this.travel_to_update).then((res:any) => {
      this.ngZone.run(() => {
        console.log(res);
        // emetti per aggiornamento griglia
        this.travelsModified.emit();
        // chiudi modal
        this.modalRef.hide();
      });
    });

  }

  modalDismiss(){
    //Evita che il viaggio passato byRef sporchi la tabella se non si invia la form
    // emetti per aggiornamento griglia
    this.travelsModified.emit();
  }


  buttonDisabler(){
    if (this.travel_status === 'inCorso'){
      this.button_disabled_status_mapping.btn_chiudi = false;
      this.button_disabled_status_mapping.btn_riapri = true;
      this.button_disabled_status_mapping.btn_modKM = false;
    }
    else if(this.travel_status === 'concluso'){
      this.button_disabled_status_mapping.btn_chiudi = true;
      this.button_disabled_status_mapping.btn_riapri = false;
      this.button_disabled_status_mapping.btn_modKM = false;
    }
    else {
      this.button_disabled_status_mapping.btn_chiudi = true;
      this.button_disabled_status_mapping.btn_riapri = true;
      this.button_disabled_status_mapping.btn_modKM = true;
    }
  }

  onClick_btn_chiudi(){
    this.input_disabled_mapping.trv_start_kilometers = false;
    this.input_disabled_mapping.trv_end_kilometers = false;
    this.input_disabled_mapping.trv_ended_at = false;
    this.input_disabled_mapping.trv_fuel_level = false;

    // permetti solo un operazione
    this.button_disabled_status_mapping.btn_chiudi = true;
    this.button_disabled_status_mapping.btn_riapri = true;
    this.button_disabled_status_mapping.btn_modKM = true;

    this.btnClicked = 'chiudi'

  }

  onClick_btn_riapri(){

    this.travel_to_update.trv_end_kilometers = null;
    this.travel_to_update.trv_ended_at = null;
    this.travel_to_update.trv_fuel_level = null;

    this.input_disabled_mapping.trv_start_kilometers = false;
    this.input_disabled_mapping.trv_end_kilometers = true;
    this.input_disabled_mapping.trv_ended_at = true;
    this.input_disabled_mapping.trv_fuel_level = true;

    // permetti solo un operazione
    this.button_disabled_status_mapping.btn_chiudi = true;
    this.button_disabled_status_mapping.btn_riapri = true;
    this.button_disabled_status_mapping.btn_modKM = true;

    this.btnClicked = 'riapri'
  }

  onClick_btn_modKM(){

    if(this.travel_status === 'inCorso'){
      this.input_disabled_mapping.trv_start_kilometers = false;
      this.input_disabled_mapping.trv_end_kilometers = true;
      this.input_disabled_mapping.trv_ended_at = true;
      this.input_disabled_mapping.trv_fuel_level = true;
    }
    else if (this.travel_status === 'concluso') {
      this.input_disabled_mapping.trv_start_kilometers = false;
      this.input_disabled_mapping.trv_end_kilometers = false;
      this.input_disabled_mapping.trv_ended_at = true;
      this.input_disabled_mapping.trv_fuel_level = true;
    }


    // permetti solo un operazione
    this.button_disabled_status_mapping.btn_chiudi = true;
    this.button_disabled_status_mapping.btn_riapri = true;
    this.button_disabled_status_mapping.btn_modKM = true;

    this.btnClicked = 'modKM'
  }

  checkForUpdate(){
    // se hai premuto su chiudi
    // TUTTI I CAMPI DEVONO ESSERE COMPILATI
    if(this.btnClicked  === 'chiudi') {
      if(
        !!this.travel_to_update.trv_start_kilometers
        &&
        !!this.travel_to_update.trv_end_kilometers
        &&
        !!this.travel_to_update.trv_ended_at
        &&
        !!this.travel_to_update.trv_fuel_level
      ) {
        console.log("ok chiudi");
        this.buttonUpdateDisabled = false;
      }
      else{
        console.log("NO chiudi");
        this.buttonUpdateDisabled = true;
      }
    }
    //se hai premuto su riapri
    // ilcampo km iniziali deve essere compilato, il campo km finali deve essere vuoto, il campo trv_ended_at vuoto, il campo level fuel vuoto
    else if(this.btnClicked  === 'riapri') {
      if(
        !!this.travel_to_update.trv_start_kilometers
        &&
        !this.travel_to_update.trv_end_kilometers
        &&
        !this.travel_to_update.trv_ended_at
        &&
        !this.travel_to_update.trv_fuel_level
      ) {
        console.log("ok riapri");
        this.buttonUpdateDisabled = false;
      }
      else{
        console.log("NO riapri");
        this.buttonUpdateDisabled = true;
      }
    }


    //se hai premuto su cambio km almeno i km iniziali devono essere compilati e se km iniziali-ended-level sono compilati lo deve essere anche km finali
    else if(this.btnClicked  === 'modKM') {

      if(this.travel_status === 'inCorso'){
        if(
          !!this.travel_to_update.trv_start_kilometers
        ) {
          console.log("ok cambio km");
          this.buttonUpdateDisabled = false;
        }
        else{
          console.log("NO cambio km");
          this.buttonUpdateDisabled = true;
        }
      }
      else if (this.travel_status === 'concluso') {
        if(
          !!this.travel_to_update.trv_start_kilometers
          &&
          !!this.travel_to_update.trv_end_kilometers
        ) {
          console.log("ok cambio km");
          this.buttonUpdateDisabled = false;
        }
        else{
          console.log("NO cambio km");
          this.buttonUpdateDisabled = true;
        }
      }




    }



  }


}
